import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@assets/colors';

const MarketClose = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33329 9.99935C3.33329 6.31745 6.31806 3.33268 9.99996 3.33268C10.4602 3.33268 10.8333 2.95959 10.8333 2.49935C10.8333 2.03911 10.4602 1.66602 9.99996 1.66602C5.39759 1.66602 1.66663 5.39698 1.66663 9.99935C1.66663 14.6017 5.39759 18.3327 9.99996 18.3327C11.3833 18.3327 13.4398 17.9245 15.1744 16.6756C16.9515 15.3961 18.3333 13.2709 18.3333 9.99935C18.3333 9.53911 17.9602 9.16602 17.5 9.16602C17.0397 9.16602 16.6666 9.53911 16.6666 9.99935C16.6666 12.7277 15.5485 14.3526 14.2005 15.3231C12.8101 16.3242 11.1166 16.666 9.99996 16.666C6.31806 16.666 3.33329 13.6812 3.33329 9.99935Z"
      fill={color}
    />
    <path
      d="M9.99996 7.49935C9.99996 7.03911 9.62686 6.66602 9.16663 6.66602C8.70639 6.66602 8.33329 7.03911 8.33329 7.49935V11.666C8.33329 12.1263 8.70639 12.4993 9.16663 12.4993H12.5C12.9602 12.4993 13.3333 12.1263 13.3333 11.666C13.3333 11.2058 12.9602 10.8327 12.5 10.8327H9.99996V7.49935Z"
      fill={color}
    />
    <path
      d="M12.5 2.49935C12.5 2.95959 12.8731 3.33268 13.3333 3.33268H15.4881L12.744 6.07676C12.5057 6.31509 12.4344 6.67352 12.5634 6.98492C12.6924 7.29631 12.9962 7.49935 13.3333 7.49935H17.5C17.9602 7.49935 18.3333 7.12625 18.3333 6.66602C18.3333 6.20578 17.9602 5.83268 17.5 5.83268H15.3451L18.0892 3.0886C18.3275 2.85027 18.3988 2.49184 18.2699 2.18045C18.1409 1.86905 17.837 1.66602 17.5 1.66602H13.3333C12.8731 1.66602 12.5 2.03911 12.5 2.49935Z"
      fill={color}
    />
  </svg>
);

MarketClose.propTypes = {
  color: string,
  size: number,
};

MarketClose.defaultProps = {
  color: N400,
  size: 20,
};

export default MarketClose;
